/**
 * Flatten a potential array of string by taking the first value.
 * @param {T} value The array of string.
 * @returns {string | T extends (null | undefined) ? undefined : never}
 */
export default function flatten<T extends string | string[] | null | undefined>(
  value: T,
): string | (T extends null | undefined ? undefined : never) {
  if (Array.isArray(value)) {
    return value?.[0] ?? undefined;
  }

  return (value as unknown as string) ?? undefined;
}
